import { useRef, useEffect } from "react";
import { Bold, Italic, Underline, AlignLeft, AlignCenter, AlignRight, List, ListOrdered, IndentIncrease, IndentDecrease } from "lucide-react";

export default function RichTextEditor({ value, onChange, testid }) {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) ref.current.innerHTML = value || "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (cmd) => {
    ref.current.focus();
    document.execCommand(cmd, false, null);
    onChange(ref.current.innerHTML);
  };

  const btn = (cmd, Icon, title) => (
    <button type="button" onMouseDown={(e) => { e.preventDefault(); exec(cmd); }} title={title} data-testid={`rte-${cmd}`}>
      <Icon size={16} />
    </button>
  );

  return (
    <div className="rte">
      <div className="rte-toolbar">
        {btn("bold", Bold, "Grassetto")}
        {btn("italic", Italic, "Corsivo")}
        {btn("underline", Underline, "Sottolineato")}
        <span className="rte-sep" />
        {btn("insertUnorderedList", List, "Elenco puntato")}
        {btn("insertOrderedList", ListOrdered, "Elenco numerato")}
        <span className="rte-sep" />
        {btn("justifyLeft", AlignLeft, "Allinea a sinistra")}
        {btn("justifyCenter", AlignCenter, "Centra")}
        {btn("justifyRight", AlignRight, "Allinea a destra")}
        <span className="rte-sep" />
        {btn("outdent", IndentDecrease, "Riduci rientro")}
        {btn("indent", IndentIncrease, "Aumenta rientro")}
      </div>
      <div
        className="rte-area"
        ref={ref}
        contentEditable
        onInput={() => onChange(ref.current.innerHTML)}
        data-testid={testid}
        suppressContentEditableWarning
      />
    </div>
  );
}
